<template>
  <div class="wrapper">
    <div class="main visual-2 /enter-phone visual-9">
      <Header backRoute="/enter-name" />
      <div class="vis4-inr1">
        <h1>Enter Your Email</h1>
        <form class="namesearch" id="emailform" @submit.prevent="handleSubmit">
          <label for="email">Email (Optional)</label>
          <input
            type="email"
            id="email"
            v-model.trim="email"
            name="email"
            placeholder="John@test.com"
          />
          <div class="sbmt">
            <button type="submit">Next</button>
          </div>
        </form>
      </div>
      <FooterView />
    </div>
  </div>
</template>

<script>
import FooterView from "@/layout/Footer.vue";
import Header from "@/layout/Header.vue";
import { lowercaseString } from "@/utils/helpers";

export default {
  components: {
    FooterView,
    Header,
  },
  name: "EnterEmail",
  data() {
    return {
      email: "",
    };
  },
  mounted() {
    // ✅ Load saved email from localStorage if available
    const savedPatient = JSON.parse(localStorage.getItem("patient"));
    if (savedPatient && savedPatient.email) {
      this.email = lowercaseString(savedPatient.email);
    }
  },
  methods: {
    handleSubmit() {
      // Retrieve the existing patient object from localStorage
      const patient = JSON.parse(localStorage.getItem("patient")) || {};

      // Save or update email
      patient.email = lowercaseString(this.email);

      // Save the updated patient object back to localStorage
      localStorage.setItem("patient", JSON.stringify(patient));

      // Navigate to the next page
      this.$router.push({
        path: "/enter-telephone",
        query: this.$route.query.code ? { code: this.$route.query.code } : {},
      });
    },
  },
};
</script>

<style scoped></style>
